import type {
  EntitlementDecision,
  FeatureKey,
  PaidPlanTier,
} from '@tabbio/types';
import { subscriptionCatalog } from '@tabbio/utils';

/**
 * The plan a lock badge names beside a feature the viewer does not have: the
 * LOWEST tier that unlocks it, read from the catalog, so the badge agrees
 * with the paywall the row opens. "Download any format" is a Plus feature; a
 * row that said PRO and then opened the Plus offer contradicted itself.
 *
 * A feature the catalog does not tier (free, but gated some other way) falls
 * back to the decision's recommended plan, then Plus.
 */
export function getFeatureLockTier(
  featureKey: FeatureKey,
  decision?: Pick<EntitlementDecision, 'recommendedTier'> | null,
): PaidPlanTier {
  const minimum = subscriptionCatalog.features[featureKey]?.minimumTier;
  if (minimum === 'plus' || minimum === 'pro') return minimum;
  return decision?.recommendedTier ?? 'plus';
}

/** The `common` copy key of the badge text for a tier ("PLUS", "PRO"). */
export function getFeatureLockLabelKey(tier: PaidPlanTier): string {
  return `upgrade.lockBadge.${tier}`;
}
